import { CommunityShotItem, ShotRemix } from 'types/community';
import EmptyRemixes from './EmptyRemixes';
import RemixesGrid from './RemixesGrid';
import styles from './RemixesSection.module.css';

type Props = {
  shotItem: CommunityShotItem;
  remixes: ShotRemix[];
};

export default function RemixesSection({ shotItem, remixes }: Props) {
  return (
    <div className={styles.Container}>
      {remixes.length ? (
        <RemixesGrid
          communityPostId={shotItem.communityPostId}
          remixes={remixes}
        />
      ) : (
        <EmptyRemixes shotItem={shotItem} />
      )}
    </div>
  );
}
